import React from "react";

export default function QuickPlayPageContentLoader() {
	return (
		<div className="skeleton">
			<div className="skeleton--quick__content">
				{Array.from({ length: 5 }, (_, index) => (
					<div className="skeleton--quick__item" key={index}>
						<div className="skeleton--quick__header">
							<div className="skeleton__empty__icon" />

							<div className="skeleton__empty" />
						</div>

						<div className="skeleton--quick__body">
							<div className="skeleton--quick__body__col">
								<span className="skeleton__empty skeleton__empty--sml" />
								<span className="skeleton__empty skeleton__empty--sml" />
							</div>
							<div className="skeleton--quick__body__col">
								<span className="skeleton__empty skeleton__empty--sml" />
								<span className="skeleton__empty skeleton__empty--sml" />
							</div>
						</div>
						<div className="skeleton--quick__footer">
							<div className="skeleton__empty skeleton__empty--sml"></div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
